import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ProductionVersionDetailPage } from './production-version-detail.page';
import { RecipeTableComponent } from './recipe-table/recipe-table.component';

export * from './production-version-detail.page';

const routes: Routes = [
    {
        path: '',
        component: ProductionVersionDetailPage,
    },
];

@NgModule({
    declarations: [ ProductionVersionDetailPage, RecipeTableComponent ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatProgressBarModule,
        MatCardModule,
        MatTableModule,
        MatSortModule,
        TranslateModule,
        MatDividerModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
    ],
    providers: [
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    ],
})
export class ProductionVersionDetailPageModule {
}
